<template>
    <div class="container" ref="container">
        <div class="pageContent">
            <main>
                <div :class="{'full-width white-bg': $mqBelow('DESKTOP')}">
                    <ActionCard :data="params.company"
                                action-name=""
                                :action="onClick"
                                :fixed-layout="false"
                                v-if="$mqBelow('DESKTOP')"
                    >
                        <template #footer>
                          <div class="flex between borderedCard" v-if="params.company.items">
                            <div v-for="item in params.company.items">
                              <span>{{item.title}}</span>
                              <span>{{item.desc}}</span>
                            </div>
                          </div>
                        </template>
                    </ActionCard>
                    <div class="full-width white-bg pos-a">
                        <div class="container tabsContainer">
                            <ATabs :tabs="tubTitles" v-model="activeTab"></ATabs>
                        </div>
                    </div>
                </div>
                <section id="mobile" class="mobileStructure" v-if="$mqBelow('DESKTOP')">
                    <Breadcrumbs class="mb-3" :items="subHeader.breadcrumbs"/>
                </section>
              <div class="about">
                <div v-for="(tab, index) in params.tabs">
                  <div v-if="activeTab==index">
                    <h3 v-if="tab.title">{{tab.title}}</h3>
                      <section class="mb-5 taskText" v-if="tab.text" v-html="tab.text"></section>
                    <ProjectListSection v-if="tab.items" :list-data="tab.items" title=""/>
                    <ReviewsListSection v-if="tab.reviews" :list-data="tab.reviews" :title="tab.reviewsTitle" :count="tab.reviewsCount"/>
                  </div>
                </div>
<!--                <div v-for="tab in params.tabs">-->
<!--                  <div v-if="tab.cityValue">-->
<!--                    <h3 v-if="tab.cityTitle">{{tab.cityTitle}}</h3>-->
<!--                    <section class="mb-5 taskText" v-if="tab.cityValue" v-html="tab.cityValue"></section>-->
<!--                  </div>-->
<!--                </div>-->
              </div>
            </main>
            <aside>
                <ActionCard :data="params.company"
                            action-name=""
                            :action="onClick"
                            v-if="$mqAbove('TABLET')"
                >
                    <template #footer>
                      <div class="flex between borderedCard" v-if="params.company.items">
                        <div v-for="item in params.company.items">
                          <span>{{item.title}}</span>
                          <span>{{item.desc}}</span>
                        </div>
                      </div>
                    </template>
                </ActionCard>
            </aside>
        </div>
    </div>
</template>

<script>
import {
  ref,
  computed, onMounted,
} from 'vue'
import {useHeader} from "../composables/useHeader";
import {AChip, ABtn,    ATab} from '~/components/ui'
import ReviewsListSection from "../components/sections/ReviewsListSection";
import ActionCard from "../components/cards/ActionCard";
import ATabs from "../components/ui/ATabs";
import ProjectListSection from "../components/sections/ProjectListSection";
import Breadcrumbs from "../components/main/Breadcrumbs";

export default {
    name: "NKOPageContainer",
    props: {
        params: {
            type: Object,
            default: {}
        }
    },
    components: {
        Breadcrumbs,
        ProjectListSection,
        ATabs,
      ATab,
        ActionCard,
        ReviewsListSection,
        AChip,
        ABtn,
    },
    setup(props) {
        const container = ref(null);
        const {subHeader} = useHeader();
        const tubTitles = computed(() => {
          let items = [];
          for(let index in props.params.tabs) {
            items.push(props.params.tabs[index].title);
          }
          return items;
        })

        const activeTab = ref(0)

        const onClick = () => {
            console.log('ONCLICK')
        }
        onMounted(() => {
          setTimeout(() => {
            window.replaceHLink(container.value);
          }, 800);
        });
        return {
            subHeader,
            activeTab,
            container,
            tubTitles,
            onClick
        }
    },
}
</script>

<style scoped lang="scss">

.about_text {

}


::v-deep .ActionCard {
    position: sticky;
    top: calc(rem(150) + rem(100));
    transform: translateY(rem(-150));

    &__footer {
        @include tablet {
            flex-grow: 1;
        }
    }

    @include tablet {
        position: relative;
        top: 0;
        transform: unset;
        box-shadow: unset;
    }
}

.tabsContainer {
    @extend %contentLayout;
}

.about {
    padding-top: rem(125);

    @include tablet {
        padding-top: 0;
    }
}
</style>